import request from './request';

export const homeApi = {
  getConfig() {
    return request.get('/api/config/getConfig');
  },
  
  getBanner() {
    return request.get('/mobile/home/getBanner');
  },
  
  getNewsList(params) {
    return request.get('/mobile/home/getNewsList', params);
  },
  
  getActivityList(params) {
    return request.get('/mobile/home/getActivityList', params);
  },
  
  getHomeGroupList() {
    return request.get('/mobile/home/getHomeGroupList');
  },
  
  getQuickEntrance() {
    return request.get('/mobile/home/getQuickEntrance');
  },
  
  getGoodslist(params) {
    return request.post('/mobile/index/getGoodslist', params);
  },
  
  getRecommendList(params) {
    return request.post('/mobile/library/getRecommendList', params);
  },
  
  getMyGroups(params) {
    return request.get('/mobile/userCenter/getMyGroups', params);
  },
  
  getCategories() {
    return request.get('/mobile/library/getCategories');
  },
  
  getArticleList(params) {
    return request.post('/mobile/library/getArticleList', params);
  },
  
  getArticleDetail(params) {
    return request.post('/mobile/library/getArticleDetail', params);
  },
  
  getArticleComments(params) {
    return request.post('/mobile/library/getArticleComments', params);
  },
  
  addArticleComment(params) {
    return request.post('/mobile/library/addArticleComment', params);
  },
  
  likeArticle(params) {
    return request.post('/mobile/library/likeArticle', params);
  },
  
  getPostDetail(params) {
    return request.post('/api/index/goodsdetail', params);
  },
  
  getPostComments(params) {
    return request.post('/api/index/goodsCommentList', params);
  },
  
  addPostComment(params) {
    return request.post('/api/index/addGoodsComment', params);
  },
  
  likePost(params) {
    return request.post('/api/index/likeGoods', params);
  },
  
  followUser(params) {
    return request.post('/mobile/user/followUser', params);
  },
  
  getContentList(params) {
    return request.post('/mobile/library/getArticleList', params);
  },
  
  getRecommendLibrary() {
    return request.post('/mobile/library/getRecommendList');
  },
  
  sendSms(params) {
    return request.post('/api/login/sendsms', params);
  },
  
  mobileLogin(params) {
    return request.post('/api/login/mobileLogin', params);
  },
  
  getUserInfo() {
    return request.post('/mobile/index/GetUser');
  },
  
  getCategoryList() {
    return request.get('/mobile/library/getCategories');
  },
  
  uploadFile(formData) {
    return request.upload('/api/common/upload', formData);
  },
  
  publishArticle(params) {
    return request.post('/mobile/library/publishArticle', params);
  },
  
  getSessionList() {
    return request.get('/mobile/index/getSessionList');
  },
  
  getMemberInfo(params) {
    return request.get('/mobile/index/getMemberInfo', params);
  },
  
  getMemberMessages(params) {
    return request.get('/mobile/index/getMemberMessages', params);
  },
  
  sendMemberMessage(params) {
    return request.post('/mobile/index/sendMemberMessage', params);
  },
  
  updateUserInfo(params) {
    return request.post('/api/user/set', params);
  },
  
  getFlowGroups(params) {
    return request.post('/api/user/flowGroup', params);
  }
};